import React from 'react';
import { Chip } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ColorPalette from '../../../../colorpalette/ColorPalette';

/** Chip de data (somente leitura) usado nos itens de histórico dos cards. */
const DateChip = ({ label, compact = false }) => (
  <Chip
    icon={<CalendarMonthOutlinedIcon fontSize="small" />}
    label={label}
    variant="outlined"
    sx={{
      backgroundColor: 'transparent',
      color: ColorPalette.textDark,
      borderColor: ColorPalette.border,
      fontWeight: 500,
      borderRadius: '8px',
      height: compact ? '24px' : '28px',
      fontSize: '13px',
      '& .MuiChip-icon': {
        color: ColorPalette.blueMain,
        marginLeft: '6px',
        marginRight: '6px',
        fontSize: compact ? '14px' : '16px',
      },
      '& .MuiChip-label': { padding: '0 8px 0 2px' },
    }}
  />
);

export default DateChip;
